import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'


const Alert = ({ type = 'info', children }) => {

  return (
    <div className="alerts-container text-left">
      <div className={ classNames('alert', {
        'alert-danger': type === 'danger' || type === 'error',
        'alert-success': type === 'success',
        'alert-warning': type === 'warning',
        'alert-info': type === 'info',
      }) }>
        { children }
      </div>
    </div>
  )
}

Alert.propTypes = {
  type: PropTypes.oneOf(['error', 'danger', 'warning', 'success', 'info']),
}

export default Alert



// WEBPACK FOOTER //
// ./src/components/common/bs-alert.js